document.addEventListener("DOMContentLoaded", function () {
	var $ = jQuery; // for convenience

	//Scroll to the top function
	$(window).on('scroll', function(){ 
		if ($(this).scrollTop() > 300) { 
			$('#scrollTop').fadeIn(); 
		} else { 
			$('#scrollTop').fadeOut(); 
		} 
	}); 
	$('#scrollTop').on('click',function(){ 
		$("html, body").animate({ scrollTop: 0 }, 600); 
		return false; 
	});

	function resizeFeatImage(){
		windowHeight = window.innerHeight;

		if (windowHeight <= 768 && $('#featured_image img').length){
			$('#global_header').css('height', windowHeight);
			$('#featured_image').css('height', windowHeight);
		}
	}


	function getWidth() {
		return Math.max(
			document.body.scrollWidth,
			document.documentElement.scrollWidth,
			document.body.offsetWidth,
			document.documentElement.offsetWidth,
			document.documentElement.clientWidth
		  );
	}
	/**
	 * Provides video files + paths, appropriate for screen size. 
	 * Given args, different videos could be returned per blog,
	 * per page.
	 * 
	 * @param id Blog id
	 * @param page Page slug
	 * @return Object
	 */
	function selectVideos(vc) {
		let id = parseInt(vc.dataset.blog);
		//let page = vc.dataset.page;
		let home = parseInt(vc.dataset.home);
		let srcPath = '/wp-content/uploads/manual/videos/';

		let sources = {};
		sources.poster = srcPath + 'poster.jpg';
		let vw = getWidth();
		let vn = 'mast-video-';
		//console.log('Width is '+vw+'px blog id is '+id+' & page is '+page);
		if(!isMobileDevice()) {
			//console.log('Desktop request');
			if(vw > 1280) {
				//console.log('HD (1080p) quality video request');
				vn += '1080';
			}
			else if(vw > 768) {
				//console.log('HD (720p) ready quality video request');
				vn += '720';
			}	
			else {
				//console.log('SD (480p) ready quality video request');
				vn += '480';
			}
		}
		else {
			//console.log('Mobile request');
			if(vw >=768) {
				//console.log('SD (480p) quality video request');
				vn += '480';
			}
			else{
				//console.log('Low (360p) quality video request');
				vn += '360';
			}
		}
		
		sources.mp4 = srcPath + vn + '.mp4';
		// All browsers support .mp4 now
		//sources.webm = srcPath + vn + '.webm';
		//sources.ogv = srcPath + vn + '.ogv';	
		return sources;
	};

	/**
	 * Test for whether device has window orientation (ie is a mobile)
	 */
	function isMobileDevice() {
		let wor = typeof window.orientation !== "undefined";
		return wor || (navigator.userAgent.indexOf('IEMobile') !== -1);
	};

	/**
	 * Work out ratio of global_header, and
	 * set video height or width to 100% 
	 * accordingly
	 */
	function resizeBgVideo(){	
		let vc = document.getElementById('mast-video');
		if(vc) {
			let h = document.getElementById('masthead');
			let hratio = h.offsetWidth / h.offsetHeight;

			//console.log('Header ratio is '+hratio)
			if(hratio > (1920 / 1080)) {
				vc.style = 'width:100%;';
			}
			else {
				vc.style = 'height:100%;'
			}
		}
	}

	/**
	 * Add sources elements to video tag,
	 * then play video
	 */
	function playBGVideo(){
		let vc = document.getElementById('mast-video');
		let p = false;
		if(vc) {

			let sources = selectVideos( vc );
			vc.setAttribute('poster', sources.poster);
			let src1 = document.createElement('source');
			src1.setAttribute('type', 'video/mp4');
			src1.setAttribute('src', sources.mp4);
			vc.appendChild(src1);
			// All browsers support .mp4 now
			/*
			let src2 = document.createElement('source');
			src2.setAttribute('type', 'video/webm');
			src2.setAttribute('src', sources.webm);
			vc.appendChild(src2);

			let src3 = document.createElement('source');
			src3.setAttribute('type', 'video/ogg');
			src3.setAttribute('src', sources.ogv);
			vc.appendChild(src3);
			*/
			// begin buffering
			vc.setAttribute('preload', 'auto');
			resizeBgVideo();
			vc.play();
			p = true;
		}
		return p;
	}
	
	// this event is kinda redundant?
	$(window).on('load', function(){ 

		let vp = playBGVideo();
		if(vp) {
			console.log('Playing video');
			window.addEventListener('resize', resizeBgVideo);
		}else{
			//console.log('Not playing video');
		}
	});
});